// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JR9qyJY7GjvEd80l0vug {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: var(--color-toolbar-bg, #f8f9fa);
  border-bottom: 1px solid var(--color-border, #e0e0e0);
  flex-wrap: wrap;
  min-height: 44px;
}

.SQf0uWw5XTT4AWTNhuws {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background-color: var(--color-surface, white);
  border-radius: 4px;
  border: 1px solid var(--color-border, #e0e0e0);
  flex: 1;
  min-width: 200px;
}

.IExlPbTMVyQA9mMHC0aN {
  font-size: 16px;
}

.ceau9t89Ok_bwPEVqV3_ {
  font-weight: 500;
  color: var(--color-text, #1a1a1a);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.ZBzIp94B1rjeMzC_zdnY {
  font-size: 11px;
  color: var(--color-text-muted, #888);
  font-family: monospace;
  background-color: var(--color-bg-muted, #f0f0f0);
  padding: 1px 4px;
  border-radius: 3px;
}

.qRBKmZ5iwkrxhZshpNgn {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.UG1VHtb_Q3h0brWGpBQt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid var(--color-border, #d0d0d0);
  border-radius: 4px;
  background-color: var(--color-surface, white);
  color: var(--color-text, #1a1a1a);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.UG1VHtb_Q3h0brWGpBQt:hover {
  background-color: var(--color-hover, #f0f0f0);
  border-color: var(--color-border-hover, #b0b0b0);
}

.UG1VHtb_Q3h0brWGpBQt:active {
  background-color: var(--color-active, #e0e0e0);
}

.UG1VHtb_Q3h0brWGpBQt:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--color-focus, #3498db);
}

.UG1VHtb_Q3h0brWGpBQt:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.YGpCELgZNRRBiHqiT1ZF {
  background-color: var(--color-primary, #2c3e50);
  color: white;
  border-color: var(--color-primary, #2c3e50);
}

.YGpCELgZNRRBiHqiT1ZF:hover {
  background-color: var(--color-primary-hover, #1a252f);
  border-color: var(--color-primary-hover, #1a252f);
}

.jtQYNqE5SsDsqt_LsYJe {
  background-color: var(--color-secondary, #3498db);
  color: white;
  border-color: var(--color-secondary, #3498db);
}

.jtQYNqE5SsDsqt_LsYJe:hover {
  background-color: var(--color-secondary-hover, #2980b9);
  border-color: var(--color-secondary-hover, #2980b9);
}

.EDsPVORwrkcpq2d8S63t {
  background-color: var(--color-info, #17a2b8);
  color: white;
  border-color: var(--color-info, #17a2b8);
}

.EDsPVORwrkcpq2d8S63t:hover {
  background-color: var(--color-info-hover, #138496);
  border-color: var(--color-info-hover, #138496);
}

.u5knUmRND8xZsP6GS76P {
  background-color: var(--color-success, #28a745);
  color: white;
  border-color: var(--color-success, #28a745);
}

.u5knUmRND8xZsP6GS76P:hover {
  background-color: var(--color-success-hover, #218838);
  border-color: var(--color-success-hover, #218838);
}

.hu0W5k1j0SLT8RzH4tao {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.hu0W5k1j0SLT8RzH4tao:hover {
  background-color: var(--color-hover, #f0f0f0);
}

.hu0W5k1j0SLT8RzH4tao input {
  width: 16px;
  height: 16px;
  accent-color: var(--color-primary, #2c3e50);
}

.C2k_VmwNnP9gufNmklvU {
  font-size: 12px;
  color: var(--color-text, #1a1a1a);
}

.hu0W5k1j0SLT8RzH4tao.TAvWo4D516FfuNpTAl6M {
  background-color: var(--color-success-light, #d4edda);
}

/* Dialogs */
.skKh80h344jn7MvYw4Ad {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: tX8edNuI3zUsJc44SQB5 0.15s ease;
}

@keyframes tX8edNuI3zUsJc44SQB5 {
  from { opacity: 0; }
  to { opacity: 1; }
}

.txgSIYIZ7Sdz0hEkzwQ1 {
  background-color: var(--color-surface, white);
  border-radius: 8px;
  padding: 20px;
  min-width: 360px;
  max-width: 480px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: pFATYY5KcFj6oezVt8Fq 0.2s ease;
}

@keyframes pFATYY5KcFj6oezVt8Fq {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.c1_jj9Q41AksAHT6KKWh {
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text, #1a1a1a);
}

.mwHi0EC4GYRb4Aa_QWbA {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--color-border, #d0d0d0);
  border-radius: 4px;
  font-size: 14px;
  color: var(--color-text, #1a1a1a);
  background-color: var(--color-surface, white);
  margin-bottom: 16px;
  box-sizing: border-box;
}

.mwHi0EC4GYRb4Aa_QWbA:focus {
  outline: none;
  border-color: var(--color-focus, #3498db);
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.mjRSD2vPVynbzFN3B3vJ {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.b4cMYMhGNfggxd_t3mdc {
  background-color: transparent;
  color: var(--color-text, #1a1a1a);
  border-color: var(--color-border, #d0d0d0);
}

.b4cMYMhGNfggxd_t3mdc:hover {
  background-color: var(--color-hover, #f0f0f0);
}

.eesI4TgihcH6BEZ5k7kH {
  background-color: var(--color-primary, #2c3e50);
  color: white;
  border-color: var(--color-primary, #2c3e50);
}

.eesI4TgihcH6BEZ5k7kH:hover {
  background-color: var(--color-primary-hover, #1a252f);
}

.eesI4TgihcH6BEZ5k7kH.ycuFGlEROWC_gJ1W5RFg {
  opacity: 0.5;
  cursor: not-allowed;
}

.SzvDq7jcTQYbAhV7SfK5 {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid var(--color-border, #e0e0e0);
  border-radius: 4px;
  margin-bottom: 16px;
}

.IX9wUB1bBEJpiqqA87Yd {
  padding: 24px;
  text-align: center;
  color: var(--color-text-muted, #888);
  margin: 0;
}

.UEI5DxmbVkCP_Ym4Sw99 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-border, #f0f0f0);
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.1s ease;
}

.UEI5DxmbVkCP_Ym4Sw99:last-child {
  border-bottom: none;
}

.UEI5DxmbVkCP_Ym4Sw99:hover {
  background-color: var(--color-hover, #f0f0f0);
}

.UEI5DxmbVkCP_Ym4Sw99.Uk0najvxL42VX63vzSNv {
  background-color: var(--color-primary-light, #e8f0fe);
}

.xdcqMjOR536zrF6PkR6c {
  font-weight: 500;
  color: var(--color-text, #1a1a1a);
  flex: 1;
}

.xWxTc4EX2sFj5g8siXNn {
  font-size: 11px;
  color: var(--color-text-muted, #888);
  margin-left: 12px;
  white-space: nowrap;
}

.UMTaXW89VMzWbzU5mruM {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  color: var(--color-text-muted, #888);
  font-size: 18px;
  cursor: pointer;
  border-radius: 3px;
  transition: all 0.1s ease;
}

.UMTaXW89VMzWbzU5mruM:hover {
  background-color: var(--color-danger-light, #f8d7da);
  color: var(--color-danger, #dc3545);
}

.co3BZ3775k8ba6FB6Ke4 {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

/* Dark mode */
@media (prefers-color-scheme: dark) {
  .JR9qyJY7GjvEd80l0vug {
    background-color: var(--color-toolbar-bg-dark, #2d2d2d);
    border-color: var(--color-border-dark, #444);
  }

  .SQf0uWw5XTT4AWTNhuws {
    background-color: var(--color-surface-dark, #333);
    border-color: var(--color-border-dark, #444);
  }

  .ceau9t89Ok_bwPEVqV3_ {
    color: var(--color-text-dark, #eee);
  }

  .ZBzIp94B1rjeMzC_zdnY {
    color: var(--color-text-muted-dark, #aaa);
    background-color: var(--color-bg-muted-dark, #444);
  }

  .UG1VHtb_Q3h0brWGpBQt {
    background-color: var(--color-surface-dark, #333);
    color: var(--color-text-dark, #eee);
    border-color: var(--color-border-dark, #555);
  }

  .UG1VHtb_Q3h0brWGpBQt:hover {
    background-color: var(--color-hover-dark, #444);
    border-color: var(--color-border-hover-dark, #666);
  }

  .txgSIYIZ7Sdz0hEkzwQ1 {
    background-color: var(--color-surface-dark, #333);
  }

  .mwHi0EC4GYRb4Aa_QWbA {
    background-color: var(--color-surface-dark, #333);
    color: var(--color-text-dark, #eee);
    border-color: var(--color-border-dark, #555);
  }

  .SzvDq7jcTQYbAhV7SfK5 {
    border-color: var(--color-border-dark, #444);
  }

  .UEI5DxmbVkCP_Ym4Sw99:hover {
    background-color: var(--color-hover-dark, #444);
  }

  .UEI5DxmbVkCP_Ym4Sw99.Uk0najvxL42VX63vzSNv {
    background-color: var(--color-primary-dark, #1e3a5f);
  }

  .xdcqMjOR536zrF6PkR6c {
    color: var(--color-text-dark, #eee);
  }

  .hu0W5k1j0SLT8RzH4tao.TAvWo4D516FfuNpTAl6M {
    background-color: var(--color-success-dark, #1e4620);
  }

  .UMTaXW89VMzWbzU5mruM:hover {
    background-color: var(--color-danger-dark, #5f1a1a);
    color: var(--color-danger-light, #f5c6cb);
  }
}

/* High contrast */
@media (prefers-contrast: high) {
  .UG1VHtb_Q3h0brWGpBQt {
    border: 2px solid currentColor;
  }

  .UG1VHtb_Q3h0brWGpBQt:focus {
    outline: 3px solid currentColor;
    outline-offset: 2px;
  }

  .txgSIYIZ7Sdz0hEkzwQ1 {
    border: 2px solid currentColor;
  }

  .UEI5DxmbVkCP_Ym4Sw99 {
    border: 1px solid currentColor;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .skKh80h344jn7MvYw4Ad,
  .txgSIYIZ7Sdz0hEkzwQ1,
  .UG1VHtb_Q3h0brWGpBQt,
  .UEI5DxmbVkCP_Ym4Sw99 {
    animation: none;
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/widget/components/workspace/WorkspaceToolbar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kDAAkD;EAClD,qDAAqD;EACrD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,8CAA8C;EAC9C,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,sBAAsB;EACtB,gDAAgD;EAChD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,6CAA6C;EAC7C,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;EACjD,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,uDAAuD;EACvD,mDAAmD;AACrD;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,kDAAkD;EAClD,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qDAAqD;AACvD;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0CAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,yCAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,6CAA6C;EAC7C,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,OAAO;AACT;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE;IACE,uDAAuD;IACvD,4CAA4C;EAC9C;;EAEA;IACE,iDAAiD;IACjD,4CAA4C;EAC9C;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,yCAAyC;IACzC,kDAAkD;EACpD;;EAEA;IACE,iDAAiD;IACjD,mCAAmC;IACnC,4CAA4C;EAC9C;;EAEA;IACE,+CAA+C;IAC/C,kDAAkD;EACpD;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,iDAAiD;IACjD,mCAAmC;IACnC,4CAA4C;EAC9C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,mDAAmD;IACnD,yCAAyC;EAC3C;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  background-color: var(--color-toolbar-bg, #f8f9fa);\r\n  border-bottom: 1px solid var(--color-border, #e0e0e0);\r\n  flex-wrap: wrap;\r\n  min-height: 44px;\r\n}\r\n\r\n.workspaceInfo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  background-color: var(--color-surface, white);\r\n  border-radius: 4px;\r\n  border: 1px solid var(--color-border, #e0e0e0);\r\n  flex: 1;\r\n  min-width: 200px;\r\n}\r\n\r\n.workspaceIcon {\r\n  font-size: 16px;\r\n}\r\n\r\n.workspaceName {\r\n  font-weight: 500;\r\n  color: var(--color-text, #1a1a1a);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 200px;\r\n}\r\n\r\n.workspaceId {\r\n  font-size: 11px;\r\n  color: var(--color-text-muted, #888);\r\n  font-family: monospace;\r\n  background-color: var(--color-bg-muted, #f0f0f0);\r\n  padding: 1px 4px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  border: 1px solid var(--color-border, #d0d0d0);\r\n  border-radius: 4px;\r\n  background-color: var(--color-surface, white);\r\n  color: var(--color-text, #1a1a1a);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.button:hover {\r\n  background-color: var(--color-hover, #f0f0f0);\r\n  border-color: var(--color-border-hover, #b0b0b0);\r\n}\r\n\r\n.button:active {\r\n  background-color: var(--color-active, #e0e0e0);\r\n}\r\n\r\n.button:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px var(--color-focus, #3498db);\r\n}\r\n\r\n.button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.saveButton {\r\n  background-color: var(--color-primary, #2c3e50);\r\n  color: white;\r\n  border-color: var(--color-primary, #2c3e50);\r\n}\r\n\r\n.saveButton:hover {\r\n  background-color: var(--color-primary-hover, #1a252f);\r\n  border-color: var(--color-primary-hover, #1a252f);\r\n}\r\n\r\n.loadButton {\r\n  background-color: var(--color-secondary, #3498db);\r\n  color: white;\r\n  border-color: var(--color-secondary, #3498db);\r\n}\r\n\r\n.loadButton:hover {\r\n  background-color: var(--color-secondary-hover, #2980b9);\r\n  border-color: var(--color-secondary-hover, #2980b9);\r\n}\r\n\r\n.importButton {\r\n  background-color: var(--color-info, #17a2b8);\r\n  color: white;\r\n  border-color: var(--color-info, #17a2b8);\r\n}\r\n\r\n.importButton:hover {\r\n  background-color: var(--color-info-hover, #138496);\r\n  border-color: var(--color-info-hover, #138496);\r\n}\r\n\r\n.exportButton {\r\n  background-color: var(--color-success, #28a745);\r\n  color: white;\r\n  border-color: var(--color-success, #28a745);\r\n}\r\n\r\n.exportButton:hover {\r\n  background-color: var(--color-success-hover, #218838);\r\n  border-color: var(--color-success-hover, #218838);\r\n}\r\n\r\n.autoSaveToggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.autoSaveToggle:hover {\r\n  background-color: var(--color-hover, #f0f0f0);\r\n}\r\n\r\n.autoSaveToggle input {\r\n  width: 16px;\r\n  height: 16px;\r\n  accent-color: var(--color-primary, #2c3e50);\r\n}\r\n\r\n.autoSaveLabel {\r\n  font-size: 12px;\r\n  color: var(--color-text, #1a1a1a);\r\n}\r\n\r\n.autoSaveToggle.enabled {\r\n  background-color: var(--color-success-light, #d4edda);\r\n}\r\n\r\n/* Dialogs */\r\n.dialogOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.15s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n.dialog {\r\n  background-color: var(--color-surface, white);\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  min-width: 360px;\r\n  max-width: 480px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n  animation: slideUp 0.2s ease;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.dialogTitle {\r\n  margin: 0 0 16px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: var(--color-text, #1a1a1a);\r\n}\r\n\r\n.dialogInput {\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  border: 1px solid var(--color-border, #d0d0d0);\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  color: var(--color-text, #1a1a1a);\r\n  background-color: var(--color-surface, white);\r\n  margin-bottom: 16px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.dialogInput:focus {\r\n  outline: none;\r\n  border-color: var(--color-focus, #3498db);\r\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\r\n}\r\n\r\n.dialogActions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n}\r\n\r\n.cancelButton {\r\n  background-color: transparent;\r\n  color: var(--color-text, #1a1a1a);\r\n  border-color: var(--color-border, #d0d0d0);\r\n}\r\n\r\n.cancelButton:hover {\r\n  background-color: var(--color-hover, #f0f0f0);\r\n}\r\n\r\n.confirmButton {\r\n  background-color: var(--color-primary, #2c3e50);\r\n  color: white;\r\n  border-color: var(--color-primary, #2c3e50);\r\n}\r\n\r\n.confirmButton:hover {\r\n  background-color: var(--color-primary-hover, #1a252f);\r\n}\r\n\r\n.confirmButton.disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.workspaceList {\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n  border: 1px solid var(--color-border, #e0e0e0);\r\n  border-radius: 4px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.emptyList {\r\n  padding: 24px;\r\n  text-align: center;\r\n  color: var(--color-text-muted, #888);\r\n  margin: 0;\r\n}\r\n\r\n.workspaceItem {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid var(--color-border, #f0f0f0);\r\n  background: none;\r\n  border: none;\r\n  width: 100%;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 0.1s ease;\r\n}\r\n\r\n.workspaceItem:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.workspaceItem:hover {\r\n  background-color: var(--color-hover, #f0f0f0);\r\n}\r\n\r\n.workspaceItem.selected {\r\n  background-color: var(--color-primary-light, #e8f0fe);\r\n}\r\n\r\n.workspaceItemName {\r\n  font-weight: 500;\r\n  color: var(--color-text, #1a1a1a);\r\n  flex: 1;\r\n}\r\n\r\n.workspaceItemDate {\r\n  font-size: 11px;\r\n  color: var(--color-text-muted, #888);\r\n  margin-left: 12px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.deleteButton {\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n  background: none;\r\n  color: var(--color-text-muted, #888);\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n  transition: all 0.1s ease;\r\n}\r\n\r\n.deleteButton:hover {\r\n  background-color: var(--color-danger-light, #f8d7da);\r\n  color: var(--color-danger, #dc3545);\r\n}\r\n\r\n.hiddenInput {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Dark mode */\r\n@media (prefers-color-scheme: dark) {\r\n  .toolbar {\r\n    background-color: var(--color-toolbar-bg-dark, #2d2d2d);\r\n    border-color: var(--color-border-dark, #444);\r\n  }\r\n\r\n  .workspaceInfo {\r\n    background-color: var(--color-surface-dark, #333);\r\n    border-color: var(--color-border-dark, #444);\r\n  }\r\n\r\n  .workspaceName {\r\n    color: var(--color-text-dark, #eee);\r\n  }\r\n\r\n  .workspaceId {\r\n    color: var(--color-text-muted-dark, #aaa);\r\n    background-color: var(--color-bg-muted-dark, #444);\r\n  }\r\n\r\n  .button {\r\n    background-color: var(--color-surface-dark, #333);\r\n    color: var(--color-text-dark, #eee);\r\n    border-color: var(--color-border-dark, #555);\r\n  }\r\n\r\n  .button:hover {\r\n    background-color: var(--color-hover-dark, #444);\r\n    border-color: var(--color-border-hover-dark, #666);\r\n  }\r\n\r\n  .dialog {\r\n    background-color: var(--color-surface-dark, #333);\r\n  }\r\n\r\n  .dialogInput {\r\n    background-color: var(--color-surface-dark, #333);\r\n    color: var(--color-text-dark, #eee);\r\n    border-color: var(--color-border-dark, #555);\r\n  }\r\n\r\n  .workspaceList {\r\n    border-color: var(--color-border-dark, #444);\r\n  }\r\n\r\n  .workspaceItem:hover {\r\n    background-color: var(--color-hover-dark, #444);\r\n  }\r\n\r\n  .workspaceItem.selected {\r\n    background-color: var(--color-primary-dark, #1e3a5f);\r\n  }\r\n\r\n  .workspaceItemName {\r\n    color: var(--color-text-dark, #eee);\r\n  }\r\n\r\n  .autoSaveToggle.enabled {\r\n    background-color: var(--color-success-dark, #1e4620);\r\n  }\r\n\r\n  .deleteButton:hover {\r\n    background-color: var(--color-danger-dark, #5f1a1a);\r\n    color: var(--color-danger-light, #f5c6cb);\r\n  }\r\n}\r\n\r\n/* High contrast */\r\n@media (prefers-contrast: high) {\r\n  .button {\r\n    border: 2px solid currentColor;\r\n  }\r\n\r\n  .button:focus {\r\n    outline: 3px solid currentColor;\r\n    outline-offset: 2px;\r\n  }\r\n\r\n  .dialog {\r\n    border: 2px solid currentColor;\r\n  }\r\n\r\n  .workspaceItem {\r\n    border: 1px solid currentColor;\r\n  }\r\n}\r\n\r\n/* Reduced motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .dialogOverlay,\r\n  .dialog,\r\n  .button,\r\n  .workspaceItem {\r\n    animation: none;\r\n    transition: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `JR9qyJY7GjvEd80l0vug`,
	"workspaceInfo": `SQf0uWw5XTT4AWTNhuws`,
	"workspaceIcon": `IExlPbTMVyQA9mMHC0aN`,
	"workspaceName": `ceau9t89Ok_bwPEVqV3_`,
	"workspaceId": `ZBzIp94B1rjeMzC_zdnY`,
	"actions": `qRBKmZ5iwkrxhZshpNgn`,
	"button": `UG1VHtb_Q3h0brWGpBQt`,
	"saveButton": `YGpCELgZNRRBiHqiT1ZF`,
	"loadButton": `jtQYNqE5SsDsqt_LsYJe`,
	"importButton": `EDsPVORwrkcpq2d8S63t`,
	"exportButton": `u5knUmRND8xZsP6GS76P`,
	"autoSaveToggle": `hu0W5k1j0SLT8RzH4tao`,
	"autoSaveLabel": `C2k_VmwNnP9gufNmklvU`,
	"enabled": `TAvWo4D516FfuNpTAl6M`,
	"dialogOverlay": `skKh80h344jn7MvYw4Ad`,
	"fadeIn": `tX8edNuI3zUsJc44SQB5`,
	"dialog": `txgSIYIZ7Sdz0hEkzwQ1`,
	"slideUp": `pFATYY5KcFj6oezVt8Fq`,
	"dialogTitle": `c1_jj9Q41AksAHT6KKWh`,
	"dialogInput": `mwHi0EC4GYRb4Aa_QWbA`,
	"dialogActions": `mjRSD2vPVynbzFN3B3vJ`,
	"cancelButton": `b4cMYMhGNfggxd_t3mdc`,
	"confirmButton": `eesI4TgihcH6BEZ5k7kH`,
	"disabled": `ycuFGlEROWC_gJ1W5RFg`,
	"workspaceList": `SzvDq7jcTQYbAhV7SfK5`,
	"emptyList": `IX9wUB1bBEJpiqqA87Yd`,
	"workspaceItem": `UEI5DxmbVkCP_Ym4Sw99`,
	"selected": `Uk0najvxL42VX63vzSNv`,
	"workspaceItemName": `xdcqMjOR536zrF6PkR6c`,
	"workspaceItemDate": `xWxTc4EX2sFj5g8siXNn`,
	"deleteButton": `UMTaXW89VMzWbzU5mruM`,
	"hiddenInput": `co3BZ3775k8ba6FB6Ke4`
};
export default ___CSS_LOADER_EXPORT___;
